import { CheckboxWithLabel, ErrorLoad, Link, StepCSSTransitionGroup } from "@wg/wows-react-uikit";
import classNames from "classnames";
import { SearchInput } from "components";
import { getLastBrawlSeason, getLastRegularSeason } from "helpers/ladder";
import { getLocalizationSafe, t } from "helpers/localization";
import { isQualifiedByBestSeasonTeam } from "helpers/seasons";
import find from "lodash/find";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import sortBy from "lodash/sortBy";
import PropTypes from "prop-types";
import * as React from "react";
import { translate } from "react-i18next";
import { SEASON_TYPES } from "reducers/ReducerRatings";
import settings from "settings";
import { ClansRatingSearchResult, ClansRatingTable, DivisionTabs, LadderSeasonsDropdown, LeagueSelector, SeasonTypeDropdown } from "UIKit";
import RealmDropdown from "../RealmDropdown/RealmDropdown";
import styles from "./ClansRating.scss";
import dwhExport from '~/dwhExport'

const propTypes = {
  urlParams: PropTypes.object,
  hasError: PropTypes.bool,
  autocomplete: PropTypes.object,
  currentAccount: PropTypes.object,
  clanInfo: PropTypes.object,
  wowsLadder: PropTypes.object,
  clanId: PropTypes.number,
  currentClanId: PropTypes.number,
  leagues: PropTypes.object.isRequired,
  seasonType: PropTypes.string,
  seasonInfo: PropTypes.shape({
    icons: PropTypes.object,
    name: PropTypes.string
  }),
  onRealmChange: PropTypes.func.isRequired,
  currentSeasonType: PropTypes.string,
  currentRealm: PropTypes.string,
  currentLeague: PropTypes.number,
  currentDivision: PropTypes.number,
  isCrossRealmLadder: PropTypes.bool,
  currentSeason: PropTypes.number,
  ratingLists: PropTypes.object,
  isError: PropTypes.bool,
  isFetching: PropTypes.bool,
  errorMessage: PropTypes.string,
  searchResult: PropTypes.shape({
    battleTypeSelected: PropTypes.string.isRequired,
    error: PropTypes.object,
    isFetchedBefore: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    meta: PropTypes.object,
    page: PropTypes.number.isRequired,
    term: PropTypes.string.isRequired
  }).isRequired,
  root: PropTypes.string.isRequired,
  onDivisionChange: PropTypes.func.isRequired,
  onLeagueChange: PropTypes.func.isRequired,
  onLeagueAndDivisionChange: PropTypes.func.isRequired,
  onSeasonTypeChange: PropTypes.func.isRequired,
  onSeasonChange: PropTypes.func.isRequired,
  onRender: PropTypes.func.isRequired,
  setCurrentClanId: PropTypes.func.isRequired,
  clanBattlesInfoContent: PropTypes.object.isRequired,

  clanHomeRealm: PropTypes.string,
  clanBattleRealm: PropTypes.string,

  clearState: PropTypes.func.isRequired,
  onAutocompleteItemClick: PropTypes.func.isRequired,
  onSearchInputChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReloadClick: PropTypes.func.isRequired,
  onPageChanged: PropTypes.func.isRequired,
  onBattleInfoClick: PropTypes.func.isRequired,
  onCrossRealmChange: PropTypes.func
};

const contextTypes = {
  router: PropTypes.object.isRequired
};

class ClansRating extends React.Component {

  constructor(props) {
    super(props);
    let leagues = this.setLeagues(this.props.leagues);

    this.state = {
      leagues,
      removeSearchState: true,
      promoSlide: 0,
      goToClan: false
    };

    this.onLeagueChange = this.onLeagueChange.bind(this);
    this.onDivisionChange = this.onDivisionChange.bind(this);

    this.onLeagueAndDivisionChange = this.onLeagueAndDivisionChange.bind(this);
    this.onAutocompleteItemClick = this.onAutocompleteItemClick.bind(this);
    this.onClanClick = this.onClanClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.onBattleInfoClick = this.onBattleInfoClick.bind(this);
    this.onSeasonTypeChange = this.onSeasonTypeChange.bind(this);
    this.onSeasonChange = this.onSeasonChange.bind(this);
    this.onRealmChange = this.onRealmChange.bind(this);
    this.onCrossRealmChange = this.onCrossRealmChange.bind(this);

    this.onSubmit = this.wrapFetchResultMethod('onSubmit');
    this.onPageChanged = this.wrapFetchResultMethod('onPageChanged');
    this.onReloadClick = this.wrapFetchResultMethod('onReloadClick');
  }

  UNSAFE_componentWillMount() {// eslint-disable-line
    this.changeRatingsByUrl();
  }

  setLeagues(leagues) {
    if (this.props.hasError) {
      return [];
    }

    let sortLeagues = Object.keys(leagues).map(el => {
      const league = leagues[el];

      return {
        content: getLocalizationSafe(league, 'mark_secondary') || getLocalizationSafe(league, 'mark'),
        divisions: league.divisions,
        value: league.number,
        icons: league.icons,
        range: league.range
      };
    });

    sortBy(sortLeagues, ['value']);

    return sortLeagues;
  }

  getLeagueDivision(props) {
    let league;
    let division;
    let leagueNumber;
    let divisionNumber;

    if (props.currentLeague === undefined) {
      league = props.leagues[1];
      leagueNumber = league.number;
    } else {
      league = props.leagues[props.currentLeague];
      leagueNumber = props.currentLeague;
    }

    if (!props.currentDivision) {
      division = league.divisions[league.divisions.length - 1];
      divisionNumber = division.number;
    } else {
      divisionNumber = props.currentDivision;
    }

    return {
      leagueNumber,
      divisionNumber
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {// eslint-disable-line
    if (!nextProps.leagues) {
      return;
    }
    this.setState(() => {
      return { leagues: this.setLeagues(nextProps.leagues) };
    });

    let nextLeagueDivision;

    if (isUndefined(nextProps.wowsLadder)) return;

    if (!this.props.wowsLadder && nextProps.wowsLadder) {
      this.props.onLeagueAndDivisionChange({
        clanId: nextProps.wowsLadder.id
      });
      return;
    }

    if (isUndefined(this.props.wowsLadder) && isNull(nextProps.wowsLadder)) {
      nextLeagueDivision = this.getLeagueDivision(nextProps);

      this.props.onLeagueAndDivisionChange({
        league: nextLeagueDivision.leagueNumber,
        division: nextLeagueDivision.divisionNumber
      });
      return;
    }

    if (!this.props.currentLeague && !this.props.currentDivision) return;

    nextLeagueDivision = this.getLeagueDivision(nextProps);

    if (this.props.currentLeague !== nextLeagueDivision.leagueNumber) this.props.onLeagueChange(nextLeagueDivision.leagueNumber);

    if (this.props.currentDivision !== nextLeagueDivision.divisionNumber) this.props.onDivisionChange(nextLeagueDivision.divisionNumber);
  }

  componentDidMount() {
    
    dwhExport.send('clan_battles.view_clan_rating')

    let ladderLeague;
    let ladderDivision;

    if (this.props.clanId && isUndefined(this.props.wowsLadder)) {
      this.props.onRender(this.props.clanId);
    } else if (this.props.wowsLadder) {
      ladderLeague = this.props.wowsLadder.league;
      ladderDivision = this.props.wowsLadder.division;
      this.props.onLeagueAndDivisionChange({
        league: this.props.currentLeague || ladderLeague,
        division: this.props.currentDivision || ladderDivision,
        clanId: this.props.currentClanId ? this.props.currentClanId : this.props.clanId,
        withGlobalSpinner: true,
        ownClan: false
      });
    } else {
      this.props.onLeagueAndDivisionChange({
        withGlobalSpinner: true
      });
    }
  }

  componentWillUnmount() {
    if (!this.state.goToClan) {
      this.props.clearState();
      this.props.setCurrentClanId(this.props.clanId);
    }
    this.abortRequest();
  }

  onLeagueChange(league) {
    this.props.onLeagueChange(league);
  }

  onDivisionChange(division) {
    this.props.onDivisionChange(division);
  }

  onLeagueAndDivisionChange({
    league,
    division,
    clanId,
    ownClan
  } = {}) {
    this.props.onLeagueAndDivisionChange({
      league,
      division,
      clanId,
      ownClan
    });
    this.setState({ removeSearchState: true });
  }

  onAutocompleteItemClick(item) {
    this.onLeagueAndDivisionChange({
      ownClan: false,
      clanId: item.id,
      league: item.league,
      division: item.division
    });
    this.setState({ removeSearchState: true });
  }

  onClanClick(clanId) {
    this.setState({
      removeSearchState: false,
      goToClan: true
    }, () => {
      this.context.router.push(`${this.props.root}clan-profile/${clanId}`);
    });
  }

  onBattleInfoClick() {
    const content = this.props.clanBattlesInfoContent;

    this.props.onBattleInfoClick(content);
  }

  isBrawl() {
    return this.currentSeasonType === SEASON_TYPES.BRAWL || this.props.currentSeasonType === SEASON_TYPES.BRAWL;
  }

  abortRequest() {
    if (this.state.request) this.state.request.abort();
  }

  handleClearClick() {
    this.abortRequest();
    this.props.clearState();
    this.setState({ removeSearchState: true });
  }

  onSeasonTypeChange(seasonType) {
    this.handleClearClick();
    this.props.onSeasonTypeChange(seasonType);
    this.currentSeasonType = seasonType;

    const season = seasonType === SEASON_TYPES.REGULAR ? getLastRegularSeason() : getLastBrawlSeason();
    if (season['id'] && this.currentSeason !== season['id']) {
      this.onSeasonChange(season['id'], seasonType);
    }
  }

  onSeasonChange(season, seasonType: number | null | undefined = null) {
    this.handleClearClick();
    this.props.onSeasonChange(season);
    this.currentSeason = parseInt(season, 10);
    if (seasonType === null) seasonType = this.props.currentSeasonType;
    this.context.router.push(`${this.props.root}clan-battles/rating/${seasonType}/${this.currentSeason}/${this.currentRealm}`);
  }

  onRealmChange(realm) {
    this.handleClearClick();
    this.props.onRealmChange(realm);
    this.currentRealm = realm;
    this.context.router.push(`${this.props.root}clan-battles/rating/${this.props.currentSeasonType}/${this.currentSeason}/${this.currentRealm}`);
  }

  changeRatingsByUrl() {
    const {
      seasonType,
      season,
      realm
    } = this.props.urlParams;

    // ORDER of parameters updates is important! season -> seasonType -> realm
    if (season) {
      this.props.onSeasonChange(season);
    }

    if (seasonType) {
      this.props.onSeasonTypeChange(seasonType);
    }

    if (realm) {
      this.props.onRealmChange(realm);
    }

    this.currentSeasonType = seasonType;
    this.currentSeason = parseInt(season || this.props.currentSeason, 10);
    this.currentRealm = realm || this.props.currentRealm;
  }

  onCrossRealmChange() {
    const isCrossRealmLadder = !this.props.isCrossRealmLadder;
    this.props.onCrossRealmChange(isCrossRealmLadder);
  }

  wrapFetchResultMethod(methodName) {
    return (...args) => {
      this.abortRequest();
      this.setState({
        request: this.props[methodName](...args),
        removeSearchState: false
      });
    };
  }

  renderRatingTableNav() {
    let currentLeague = (this.state.leagues[0] && this.state.leagues[0].value !== 0) ? this.props.currentLeague - 1 : this.props.currentLeague;
    if (currentLeague === -1) currentLeague = 0;

    if (this.state.removeSearchState) {
      const divisions = (this.state.leagues[currentLeague] && this.state.leagues[currentLeague].divisions) ? this.state.leagues[currentLeague].divisions : [];
      return <div>
        <StepCSSTransitionGroup level={2}>
          <div>
            <StepCSSTransitionGroup level={1}>
              <div className={styles.tableMenu}>
                <LeagueSelector key="league-selector" items={this.state.leagues} selected={this.props.currentLeague} onLeagueChange={this.onLeagueChange} />
                <DivisionTabs key="division-tabs" items={divisions} selected={this.props.currentDivision} onDivisionChange={this.onDivisionChange} />
              </div>
            </StepCSSTransitionGroup>

          </div>
        </StepCSSTransitionGroup>
      </div>;
    }
  }

  renderSearchResult(searchResult) {
    if (!this.state.removeSearchState) {
      return <StepCSSTransitionGroup level={3}>
        <ClansRatingSearchResult key="search-result" currentAccount={this.props.currentAccount} searchResult={searchResult} currentSeason={this.props.currentSeason} isCrossRealmLadder={this.props.isCrossRealmLadder} onItemClick={this.onLeagueAndDivisionChange} onPageChanged={this.onPageChanged} onReloadClick={this.onReloadClick} />
      </StepCSSTransitionGroup>;
    } else {
      return null;
    }
  }

  renderClansRating() {
    let clans;

    if (!this.props.currentDivision) return null;

    if (this.props.ratingLists[this.props.currentLeague]) {
      clans = this.props.ratingLists[this.props.currentLeague][this.props.currentDivision];
    }

    if (!clans) clans = [];

    if (this.state.removeSearchState) {
      return <div>
        <StepCSSTransitionGroup level={4}>
          <ClansRatingTable clanId={this.props.currentClanId} clans={clans} isCrossRealmLadder={this.props.isCrossRealmLadder} stickyContainerId="clans-rating-container" isError={this.props.isError} isFetching={this.props.isFetching} errorMessage={this.props.errorMessage} currentLeague={this.props.currentLeague} currentDivision={this.props.currentDivision} isOldSeason={settings.ladder.lastSeasonId !== this.props.currentSeason} seasonType={this.props.seasonType} onLeagueChange={this.onLeagueChange} onDivisionChange={this.onDivisionChange} onClanClick={this.onClanClick} />
        </StepCSSTransitionGroup>
      </div>;
    }
  }

  renderSeasonsMenu() {
    return <div className={styles.season}>
      <SeasonTypeDropdown selectedSeasonType={this.currentSeasonType || this.props.currentSeasonType} onSeasonTypeChange={this.onSeasonTypeChange} displayIcons={true} />
      <LadderSeasonsDropdown selectedSeasonId={parseInt(this.currentSeason || this.props.currentSeason, 10)} selectedSeasonType={this.currentSeasonType || this.props.currentSeasonType} onSeasonChange={this.onSeasonChange} />
      <RealmDropdown clanHomeRealm={this.props.clanHomeRealm} clanBattleRealm={this.props.clanBattleRealm} itemSelected={this.props.currentRealm} onRealmChange={this.onRealmChange} isBrawl={this.isBrawl()} />
    </div>;
  }

  renderRealmCheckbox() {
    return settings.ladder.isCrossRealmLadderEnabled ? <div className={styles.crossRealmCheckboxWrap}>
      <CheckboxWithLabel isChecked={this.props.isCrossRealmLadder} labelText={t('Глобальный рейтинг')} onChange={this.onCrossRealmChange} />
    </div> : null;
  }

  goToMyPosition = () => {
    const seasonData = find(this.props.wowsLadder.ratings, { season_number: this.currentSeason || this.props.currentSeason });
    if (seasonData) {
      this.onLeagueAndDivisionChange({
        league: seasonData.league,
        division: seasonData.division,
        clanId: this.props.clanId
      });
    }
  };

  render() {
    if (this.props.hasError) {
      return <StepCSSTransitionGroup level={1}>
        <ErrorLoad key="error-load" message={t('Произошла ошибка. Повторите попытку позже')} onReloadClick={() => { }} t={t} />
      </StepCSSTransitionGroup>;
    }

    const totalClans = this.props.autocomplete.meta && this.props.autocomplete.meta.total_clans;

    let isQualified;

    if (!this.props.currentDivision) return null;

    if (this.props.wowsLadder) {
      isQualified = isQualifiedByBestSeasonTeam(this.props.wowsLadder.ratings, this.props.currentSeason, this.props.currentRealm);
    } else {
      isQualified = false;
    }

    const hidetableMenu = this.state.leagues && this.state.leagues.length === 1;

    return <div className={styles.container}>
      <StepCSSTransitionGroup level={1}>
        {this.renderSeasonsMenu()}
      </StepCSSTransitionGroup>
      <StepCSSTransitionGroup level={2}>
        {hidetableMenu ? null : this.renderRatingTableNav()}
        <div className={styles.ratingTableNav}>
          <div>
            <Link isActionLink onClick={() => this.onLeagueAndDivisionChange()}>
              {t('Лидеры сезона')}
            </Link>
            <div className={classNames(styles.clanPresent, { [styles.isShow]: isQualified })}>
              <Link isActionLink arrow="down" onClick={this.goToMyPosition}>
                {t('Перейти к позиции моего клана')}
              </Link>
            </div>
            <div className={classNames(styles.clanAbsent, { [styles.isShow]: !isQualified && this.props.clanId })}>
              {t('В выбранном регионе ваш клан отсутствует в рейтинге')}
            </div>
          </div>
          <div className={styles.searchInputWrap} data-staff-name="ratings_search-input">
            <SearchInput key="search-input" isGlobalSearch={this.props.isCrossRealmLadder} autocompleteFoundByTerm={this.props.autocomplete.foundByTerm} autocompleteItems={this.props.autocomplete.items} autocompleteTotalClans={totalClans} isAutocompleteFetching={this.props.autocomplete.isFetching} isClanUser={Boolean(this.props.clanId)} searchHistory={{ items: [] }} term={this.props.searchResult.term} onAutocompleteItemClick={this.onAutocompleteItemClick} onHistoryItemClick={this.onAutocompleteItemClick} onClearClick={this.handleClearClick} onSearchInputChange={this.props.onSearchInputChange} onSubmit={this.onSubmit} />
          </div>
        </div>
      </StepCSSTransitionGroup>
      {this.renderSearchResult(this.props.searchResult)}
      {this.renderClansRating(this.props.searchResult)}
    </div>;
  }
}

ClansRating.propTypes = propTypes;
ClansRating.contextTypes = contextTypes;

export default translate()(ClansRating);